import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Container, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class Containers {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Container>> => {
    const response = await this.api.get('/logistics/containers', config)
    return paginatedTransform(Container)(response.data)
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Container> => {
    const response = await this.api.get(`/logistics/containers/${guid}`, config)
    return rawTransform(Container)(response.data)
  }
}
